import React from "react";
import { NavLink } from "react-router-dom";
import "./Subnav.scss";
//assets
import icon_label from "../../assets/icons/icon-label.svg";

export default function SubNav(props) {
	return (
		<NavLink to={`${props.item.path}`} className="subnav__item d-block">
			<div className="d-flex justify-content-between mb-3">
				<div className="subnav__item-label d-flex align-items-center fw--600 color--primary">
					<div>
						<img src={icon_label} alt="Label icon" className="mr-2" />
					</div>
					Course
				</div>
				<div className="subnav__item-label fw--500">{props.item.amountVideo} materials</div>
			</div>
			<div className="d-flex justify-content-between">
				<div className="subnav__item-title">{props.item.name}</div>
				{props.item.newVideos > 0 && <div className="subnav__item-badge d-inline-block">{props.item.newVideos} new</div>}
			</div>
		</NavLink>
	);
}
